import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { printAssignmentRightSide } from '../slang-printers/print-assignment-right-side.js';
import { extractVariant } from '../slang-utils/extract-variant.js';
import { SlangNode } from './SlangNode.js';
import { Expression } from './Expression.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class StateVariableDefinitionValue extends SlangNode {
  readonly kind = NonterminalKind.StateVariableDefinitionValue;

  value: Expression['variant'];

  constructor(
    ast: ast.StateVariableDefinitionValue,
    collected: CollectedMetadata
  ) {
    super(ast, collected);

    this.value = extractVariant(new Expression(ast.value, collected));

    this.updateMetadata(this.value);
  }

  print(print: PrintFunction): Doc {
    return [' =', printAssignmentRightSide(print('value'), this.value)];
  }
}
